import { useLayoutEffect, useRef, useState } from 'react'

/**
 * Gerekçe metni — telefonda katlanmış, masaüstünde olduğu gibi.
 *
 * Bu panelin karakteri "sayıyı söyle, gerekçesini de söyle" üzerine kurulu ve
 * bu metinler bilerek uzun. Ama telefonda toplamı bir duvara dönüşüyordu:
 * Takip sekmesi 390px genişlikte 7 ekran uzunluğundaydı ve ekranın çoğu
 * açıklamaydı — kullanıcı günde on kez aynı paragrafı geçmek zorunda kalıyor.
 *
 * Çözüm metni silmek değil, KATLAMAK: iki satır görünüyor, gerisi dokununca
 * açılıyor. Açıklama duruyor, sadece ilk okuyuşta ödenen bir bedel oluyor.
 *
 * "devamı" düğmesi paragrafın DIŞINDA duruyor: `-webkit-line-clamp` kutunun
 * içindeki her şeyi kestiği için düğme de kesilirdi. Ayrıca sadece metin
 * gerçekten taşıyorsa çiziliyor — üç satırlık bir nota "devamı" koymak gürültü.
 */
export function Prose({ className = 'note', style, children }: {
  className?: 'note' | 'card-h' | 'sub'
  style?: React.CSSProperties
  children: React.ReactNode
}) {
  const ref = useRef<HTMLParagraphElement>(null)
  const [open, setOpen] = useState(false)
  const [clipped, setClipped] = useState(false)

  useLayoutEffect(() => {
    const el = ref.current
    // Açıkken ölçmüyoruz: açık halde taşma olmaz, `clipped` false'a düşer ve
    // "kısalt" düğmesi kaybolurdu.
    if (!el || open) return
    const check = () => setClipped(el.scrollHeight > el.clientHeight + 2)
    check()
    const ro = new ResizeObserver(check)
    ro.observe(el)
    return () => ro.disconnect()
  }, [children, open])

  return (
    <>
      <p ref={ref} className={className} data-open={open ? 'true' : undefined} style={style}>
        {children}
      </p>
      {clipped && (
        <button className="prose-toggle" aria-expanded={open} onClick={() => setOpen(!open)}>
          {open ? 'kısalt' : 'devamını oku'}
        </button>
      )}
    </>
  )
}
